import type { SVGProps } from 'react';

export const InputCheckbox = (props: SVGProps<any>) => (
  <svg
    height="32px"
    role="img"
    viewBox="0 0 32 32"
    width="32px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{'input checkbox'}</title>
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <circle cx="16" cy="16" fill="#F2F4F9" r="16" />
      <g transform="translate(6, 6)">
        <g stroke="#898C9A">
          <rect height="19" width="19" x="0.5" y="0.5" />
        </g>
        <g fill="#898C9A" transform="translate(4.8606, 6.7811)">
          <path d="M4.33333333,7.66666667 C4.14488889,7.66666667 3.96355556,7.592 3.83022222,7.45777778 L0.208,4.04977778 C0.0746666667,3.91644444 0,3.736 0,3.54666667 C0,3.35733333 0.0746666667,3.17688889 0.208,3.04444444 L0.712,2.54133333 C0.850666667,2.40266667 1.032,2.33333333 1.21422222,2.33333333 C1.39644444,2.33333333 1.57777778,2.40266667 1.71733333,2.54133333 L4.33333333,5 L8.94933333,0.208 C9.08266667,0.0746666667 9.264,0 9.45244444,0 L9.45244444,0 C9.64088889,0 9.82222222,0.0746666667 9.95555556,0.208 L10.4586667,0.710222222 C10.736,0.988444444 10.736,1.43911111 10.4586667,1.71644444 L4.83644444,7.45777778 C4.70311111,7.592 4.52177778,7.66666667 4.33333333,7.66666667" />
        </g>
      </g>
    </g>
  </svg>
);
